var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-area"},[_c('svg-icon',{staticClass:"icon-no-data",attrs:{"icon-class":_vm.iconAddress}}),_c('p',{staticClass:"no-data-title",style:({ color: _vm.fontColor })},[_vm._v(" "+_vm._s(_vm.info || '暂无数据')+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }